export default __webpack_public_path__ + "assets/images/icon-microphone.ce06c84f51f463dc652491003e07b1a6.svg";